import '../styles.css';
import chopsticksAccent from '../assets/chopsticks-accent.svg';
import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import HomeSlider from '../components/HomeSlider';

export function useMetadata(metadata) {
    useEffect(() => {
        // Set Title
        if (metadata.title) {
            document.title = metadata.title;
        }

        // Meta tag Helper
        const updateMeta = (metaname, content, attribute = 'name') => {
            let element = document.querySelector(
                `meta[${attribute}="${metaname}"]`,
            );
            if (element) {
                element.setAttribute('content', content);
            } else {
                element = document.createElement('meta');
                element.setAttribute(attribute, metaname);
                element.setAttribute('content', content);
                document.head.appendChild(element);
            }
        };

        if (metadata.charset) {
            let charsetElement = document.querySelector('meta[charset]');
            if (charsetElement) {
                charsetElement.setAttribute('charset', metadata.charset);
            } else {
                charsetElement = document.createElement('meta');
                charsetElement.setAttribute('charset', metadata.charset);
                document.head.insertBefore(
                    charsetElement,
                    document.head.firstChild,
                );
            }
        }

        if (metadata.viewport) {
            updateMeta('viewport', metadata.viewport);
        }

        if (metadata.description) {
            updateMeta('description', metadata.description);
        }
        if (metadata.keywords) {
            updateMeta('keywords', metadata.keywords);
        }

        if (metadata.author) {
            updateMeta('author', metadata.author);
        }

        if (metadata.ogTitle) {
            updateMeta('og:title', metadata.ogTitle, 'property');
        }
        if (metadata.ogDescription) {
            updateMeta('og:description', metadata.ogDescription, 'property');
        }
        if (metadata.ogImage) {
            updateMeta('og:image', metadata.ogImage, 'property');
        }
        if (metadata.ogUrl) {
            updateMeta('og:url', metadata.ogUrl, 'property');
        }
    }, [metadata]);
}

export default function Main() {
    useMetadata({
        charset: 'UTF-8',
        viewport: 'width=device-width, initial-scale=1.0',
        description:
            'CHOPSTICKSTORY - Sharing Korean culture through meaningful experiences. Discover our hands-on programs including chopstick woodcraft, lotus and hanji lanterns, dancheong pattern art, K-archery, and mother-of-pearl craft.',
        keywords:
            'Korean culture, cultural education, Korean craft workshop, chopsticks, lotus lantern, dancheong, K-archery, hanji lantern, mother of pearl',
        author: 'CHOPSTICKSTORY',
        ogTitle: 'CHOPSTICKSTORY - Celebrating Korean Culture',
        ogDescription:
            'Join us in our journey to connect cultures through meaningful experiences.',
        ogImage: 'https://chopstickstory.org/images/STAMP-LOGO.webp',
        ogUrl: 'https://chopstickstory.org/',
    });

    // Load Instagram feed
    useEffect(() => {
        const loadBeholdFeed = async () => {
            const BEHOLD_FEED_URL =
                'https://feeds.behold.so/QmrH8sxjg7rmJixicWYy';
            const instagramGrid = document.getElementById('instagram-grid');

            if (!instagramGrid) return;

            try {
                const response = await fetch(BEHOLD_FEED_URL);
                const data = await response.json();

                instagramGrid.innerHTML = '';

                // behold.json 구조에 맞게 데이터 추출
                // posts 배열에 최대 6개 포스트만 표시
                const posts = data.posts?.slice(0, 6) || [];

                posts.forEach((post) => {
                    // 미디어 URL 결정 (sizes.medium 또는 대체 이미지)
                    let mediaUrl;
                    if (post.mediaType === 'VIDEO' && post.thumbnailUrl) {
                        // 비디오인 경우 썸네일 사용
                        mediaUrl = post.thumbnailUrl;
                    } else if (post.sizes && post.sizes.medium) {
                        // medium 사이즈 이미지 사용
                        mediaUrl = post.sizes.medium.mediaUrl;
                    } else {
                        // 기본 미디어 URL 사용
                        mediaUrl = post.mediaUrl;
                    }

                    // 캡션 정리 (짧은 버전 사용)
                    const caption = post.prunedCaption || post.caption || '';

                    // 포스트 타입에 따른 아이콘 추가
                    const isVideo = post.mediaType === 'VIDEO' || post.isReel;
                    const icon = isVideo
                        ? '<i class="fa-solid fa-play post-icon"></i>'
                        : '';

                    const postElement = document.createElement('a');
                    postElement.href = post.permalink;
                    postElement.target = '_blank';
                    postElement.rel = 'noopener';
                    postElement.className = `instagram-post ${isVideo ? 'video-post' : ''}`;
                    postElement.innerHTML = `
                        <img src="${mediaUrl}" alt="${caption ? caption.slice(0, 100) : 'Instagram post'}" loading="lazy">
                        ${icon}
                        <div class="post-overlay">
                            <span class="post-likes">
                                <i class="fa-solid fa-heart"></i>
                            </span>
                        </div>
                    `;
                    instagramGrid.appendChild(postElement);
                });
            } catch (error) {
                console.error('Error loading Behold Instagram feed:', error);
                // 에러 발생 시 대체 콘텐츠 표시
                instagramGrid.innerHTML = `
                    <div style="text-align: center; grid-column: 1/-1; padding: 2rem;">
                        <p>Instagram 피드를 불러오는 중 문제가 발생했습니다.</p>
                        <a href="https://www.instagram.com/chopstickstory/" target="_blank">Instagram에서 직접 보기</a>
                    </div>
                `;
            }
        };

        loadBeholdFeed();
    }, []);

    return (
        // <html lang="ko">
        <div>
            {/* <title>CHOPSTICKSTORY - Celebrating Korean Culture</title> */}
            {/* <link rel="icon" type="image/webp" href="./images/cropped-cropped-CHOPSTICKSTORY-7.webp"> */}
            {/* <body> */}

            <main>
                <HomeSlider />
            </main>

            <section className="instagram-feed">
                <div className="container">
                    <h2 className="section-title">
                        Discover Our Latest Moments
                        <img
                            src={chopsticksAccent}
                            alt=""
                            aria-hidden="true"
                            className="title-accent"
                        />
                    </h2>
                    <p className="section-subtitle">
                        Join our growing community of chopstick storytellers
                    </p>
                    <div className="instagram-grid" id="instagram-grid">
                        {/* <!-- Instagram posts will be loaded here dynamically --> */}
                    </div>
                    <div className="social-icons-container">
                        <a
                            href="https://www.instagram.com/chopstickstory/"
                            className="instagram-icon-link"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Visit our Instagram"
                        >
                            <div className="instagram-icon-gradient">
                                <i className="fa-brands fa-instagram"></i>
                            </div>
                        </a>

                        <a
                            href="https://www.linkedin.com/company/chopstickstory/"
                            className="linkedin-icon-link"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Visit our LinkedIn"
                        >
                            <div className="linkedin-icon-gradient">
                                <i className="fa-brands fa-linkedin-in"></i>
                            </div>
                        </a>

                        <a
                            href="https://www.youtube.com/@CHOPSTICKSTORY"
                            className="youtube-icon-link"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Visit our YouTube channel"
                        >
                            <div className="youtube-icon-gradient">
                                <i className="fa-brands fa-youtube"></i>
                            </div>
                        </a>
                    </div>
                </div>
            </section>

            <Footer />
            {/* <script src="https://kit.fontawesome.com/b3f4de9307.js" 
            crossorigin="anonymous"></script>
            <script src="js/main.js"></script>
            <script src="js/header-scroll.js"></script>
            <script src="js/nav-scroll.js"></script> */}
            {/* </body> */}
            {/* </html> */}
        </div>
    );
}
